/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderPlus: {
  name: 'folder-plus';
  data: string;
} = {
  name: 'folder-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.586L10 3.586A2 2 0 0 0 8.586 3H4Zm0 2h4.586L11 7.414A2 2 0 0 0 12.414 8H20v10H4V5Zm8 5a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
